$(window).on("load", function () {
  if ($(".discountedpricepp").length > 0) {
    $("body").addClass("discountedProduct");
  }
});
    $(window).on("load", function () {
  // Initialize Slick only on screen widths below 1024px
  if ($(window).width() < 768) {
    $('.mobile-slick-slider').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
});



$(function () {
  if ($("body").hasClass("template-product")) {
    $(".s-slickcarousel")
      .not(".slick-initialized")
      .slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: true,
        easing: "linear",
        fade: false,
        arrows: true,
        prevArrow:
          '<button type="button" data-role="none" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/download-icon-arrow_left_chevron_chevronleft_left_left_icon_icon-1320185731545502691_48_1.png?v=1655797122"></button>',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/download-icon-arrow_right_chevron_chevronright_right_right_icon_icon-1320185732203239715_48_2.png?v=1655796938"></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
              draggable: true,
            },
          },
        ],
      });
  } else {
  }
});
$(document).ready(function () {
  $(".html-generate-button").click(function (e) {
    var getHTMLCode = $("#Layout1Content").html();
    $("#generating-code").text(
      '<div class="product-single__content" id="Layout1Content">' +
        getHTMLCode +
        "</div>"
    );
  });
  $(".layout2-html-generate-button").click(function (e) {
    var getHTMLCode1 = $(
      "#shopify-section-template--14601189720134__16559767677a117ebb #Layout2Content"
    ).html();
    var getHTMLCode2 = $(
      "#shopify-section-template--14601189720134__16559770465fa3c04e #Layout2Content"
    ).html();
    var getHTMLCode3 = $(
      "#shopify-section-template--14601189720134__16559776312c5a4736 #Layout2Content"
    ).html();
    var getHTMLCode4 = $(
      "#shopify-section-template--14601189720134__16559782591818db33 #Layout2Content"
    ).html();
    var getHTMLCode5 = $(
      "#shopify-section-template--14601189720134__1655978831cc1caabf #Layout2Content"
    ).html();
    var getHTMLCode6 = $(
      "#shopify-section-template--14601189720134__1655978975b7c7e523 #Layout2Content"
    ).html();
    var getHTMLCode7 = $(
      "#shopify-section-template--14601189720134__16559797344dfe7339 #Layout2Content"
    ).html();
    $("#layout2-generating-code").text(
      '<div class="product-single__content-Layout2" id="Layout2Content">' +
        getHTMLCode1 +
        getHTMLCode2 +
        getHTMLCode3 +
        getHTMLCode4 +
        getHTMLCode5 +
        getHTMLCode6 +
        getHTMLCode7 +
        "</div>"
    );
  });
  if (window.matchMedia("(max-width: 1024px)").matches) {
    var headerHeight = $("header").outerHeight();
    $(".top_filter_button").css("top", headerHeight);
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 50) {
        $("body").addClass("CustomFixed");
        $(".top_filter_button").css("top", "67.02px");
      } else {
        $("body").removeClass("CustomFixed");
        $(".top_filter_button").css("top", headerHeight);
      }
    });

    var position = $(window).scrollTop();
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= position) {
        $(".top_filter_button").addClass("hide-filter");
      } else {
        $(".top_filter_button").removeClass("hide-filter");
      }
      position = scroll;
    });
  }
});

// DeliveryDate on product page
$(function () {
  setTimeout(function () {
    function addDays(theDate, days) {
      return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
    }
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const dateObj = new Date();
    const datesvar = addDays(new Date(), 3);
    const month = monthNames[dateObj.getMonth()];
    const day = String(dateObj.getDate() + 3).padStart(2, "0");
    const year = dateObj.getFullYear();
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    var GetWeekday = weekday[datesvar.getDay()];
    const output = GetWeekday + ", " + month + " " + day;
    var newOutput = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
    var res = String(newOutput).slice(0, 15);

    const startDate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);
    const endDate = new Date(Date.now() + 9 * 24 * 60 * 60 * 1000);

    const options = { month: "short", day: "numeric" };
    const startDateFormatted = startDate.toLocaleDateString("en-US", options);
    const endDateFormatted = endDate.toLocaleDateString("en-US", options);

    const result = `${startDateFormatted} to ${endDateFormatted}`;

    if (
      $(".custom__product__info .how_to_get_it span#DeliveryDate").is(
        ":empty"
      )
    ) {
      $(".custom__product__info .how_to_get_it span#DeliveryDate").append(
        "<span>Estimated By: " + result + "</span>"
      );
    }
  }, 2000);
});

// End DeliveryDate on product page

$(function () {
  var d = new Date();
  var weekday = new Array(7);
  weekday[0] = "Sunday";
  weekday[1] = "Monday";
  weekday[2] = "Tuesday";
  weekday[3] = "Wednesday";
  weekday[4] = "Thursday";
  weekday[5] = "Friday";
  weekday[6] = "Saturday";

  var n = weekday[d.getDay()];
  if (n == "Sunday") {
    $("#LocationDay").text("11:00 AM - 05:00 PM");
    $("#StoreHour").text("Open until 5 pm");
    $("#StoreTwoHour").text("Open until 5 pm");
  }
  if (n == "Monday") {
    $("#LocationDay").text("10:00 AM - 06:00 PM");
    $("#StoreHour").text("Open until 6 pm");
    $("#StoreTwoHour").text("Open until 6 pm");
  }
  if (n == "Tuesday") {
    $("#LocationDay").text("10:00 AM - 06:00 PM");
    $("#StoreHour").text("Open until 6 pm");
    $("#StoreTwoHour").text("Open until 6 pm");
  }
  if (n == "Wednesday") {
    $("#LocationDay").text("10:00 AM - 06:00 PM");
    $("#StoreHour").text("Open until 6 pm");
    $("#StoreTwoHour").text("Open until 6 pm");
  }
  if (n == "Thursday") {
    $("#LocationDay").text("10:00 AM - 06:00 PM");
    $("#StoreHour").text("Open until 6 pm");
    $("#StoreTwoHour").text("Open until 6 pm");
  }
  if (n == "Friday") {
    $("#LocationDay").text("10:00 AM - 06:00 PM");
    $("#StoreHour").text("Open until 6 pm");
    $("#StoreTwoHour").text("Open until 6 pm");
  }
  if (n == "Saturday") {
    $("#LocationDay").text("10:00 AM - 06:00 PM");
    $("#StoreHour").text("Open until 6 pm");
    $("#StoreTwoHour").text("Open until 6 pm");
  }
});

$(window).on("load", function () {
  $(".product-page-info__customreview").css("visibility", "visible");
  if ($(".discountedpricepp").length > 0) {
    $("body").addClass("CustomDiscountPrice");
  }
});

$(function () {
  jQuery("ul.top-header-menu li.children a.children-link").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent().toggleClass("active");
    $("html").toggleClass("top-header-menu-active");
  });

  jQuery("ul.top-header-menu li ul.submenu .top-header-menu-overlay").click(
    function () {
      jQuery("ul.top-header-menu li.children").removeClass("active");
      jQuery("html").removeClass("top-header-menu-active");
    }
  );

  jQuery("ul.top-header-menu li.children a ul li a").click(function () {
    jQuery("ul.top-header-menu li.children").removeClass("active");
    jQuery("html").removeClass("top-header-menu-active");
  });
});

$(function () {
  function haversineDistance(lat1, lon1, lat2, lon2) {
    // Radius of the earth in miles
    const R = 3958.8;

    // Convert degrees to radians
    const lat1Rad = toRadians(lat1);
    const lon1Rad = toRadians(lon1);
    const lat2Rad = toRadians(lat2);
    const lon2Rad = toRadians(lon2);

    // Differences in coordinates
    const dLat = lat2Rad - lat1Rad;
    const dLon = lon2Rad - lon1Rad;

    // Haversine formula
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // Distance in miles
    const distance = R * c;

    return distance;
  }

  function toRadians(degrees) {
    return degrees * (Math.PI / 180);
  }
  if (!localStorage.getItem("geoExpire")) {
    $.getScript("//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js")
      .done(function (script, textStatus) {
        var onSuccess = function (location) {
          var geoLocationData = location;
          var firstTime = {
            value: geoLocationData,
            timestamp: new Date().getTime(),
          };
          localStorage.setItem("geoExpire", JSON.stringify(firstTime));
          geoSucess(location);
        };
        var onError = function (error) {};
        geoip2.city(onSuccess, onError);
      })
      .fail(function (jqxhr, settings, exception) {});
  } else {
    var your_data = JSON.parse(localStorage.getItem("geoExpire"));
    var dateString = your_data.timestamp;
    var currentTime = new Date().getTime().toString();
    timeDifference(currentTime, dateString);
    geoSucess(your_data.value);
  }

  function timeDifference(timestamp1, timestamp2) {
    var difference = timestamp1 - timestamp2;
    var differenceInSeconds = difference / 1000;
    var differenceInMinutes = differenceInSeconds / 60;
    var differenceInHours = differenceInMinutes / 60;
    if (differenceInHours >= 8) {
      localStorage.removeItem("geoExpire");
      setTimeout(function () {
        $.getScript("//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js")
          .done(function (script, textStatus) {
            var onSuccess = function (location) {
              var geoLocationData = location;
              var firstTime = {
                value: geoLocationData,
                timestamp: new Date().getTime(),
              };
              localStorage.setItem("geoExpire", JSON.stringify(firstTime));
              geoSucess(location);
            };
            var onError = function (error) {};
            geoip2.city(onSuccess, onError);
          })
          .fail(function (jqxhr, settings, exception) {});
      }, 500);
    }

    return differenceInHours;
  }

  function geoSucess(location) {
    // console.log("location", location);
    // var userLat = 33.0499398;
    // var userLong = -96.4015656;
    var userLat = location.location.latitude;
    var userLong = location.location.longitude;
    var myAddressLat = 32.9490721;
    var myAddressLong = -96.8293635;
    var distance = haversineDistance(
      userLat,
      userLong,
      myAddressLat,
      myAddressLong
    );
    console.log(
      "Distance between user and my address location:",
      distance.toFixed(2),
      "miles"
    );

    if (distance >= 40) {
      $("body").addClass("hide-delivery-option");
      // $('.free-delivery-part').hide();
      // $('.installation-part').hide();
      // $('.custom-product-page__main .product-page-main .product-page-info .custom__product__info .how_to_get_it ul li:nth-child(2), .custom-product-page__main .product-page-main .product-page-info .custom__product__info .how_to_get_it ul li:nth-child(3)').hide();
    } else {
      console.log("User is within 40 miles.");
    }
  }
});

// Timer code
class CountdownTimer {
  constructor(duration, elementId) {
    this.duration = duration;
    this.elementId = elementId;
    
    // Safely try to get from localStorage
    try {
      const storedTime = localStorage.getItem(`${this.elementId}_endTime`);
      if (storedTime) {
        this.endTime = parseInt(storedTime);
      } else {
        this.endTime = Date.now() + this.duration;
      }
    } catch (e) {
      // localStorage might be blocked in some environments
      console.warn('localStorage not available for countdown timer');
      this.endTime = Date.now() + this.duration;
    }
    
    this.timer = null;
  }

  formatTime(milliseconds) {
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    const minutes = Math.floor((milliseconds % 3600000) / 60000);
    const hours = Math.floor(milliseconds / 3600000);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  updateTimerDisplay() {
    const remainingTime = this.endTime - Date.now();
    
    // Get timer element and check if it exists
    const timerElement = document.getElementById(`${this.elementId}_timer`);
    if (timerElement) {
      timerElement.textContent = this.formatTime(remainingTime);
    }
    
    // Get progress bar element and check if it exists
    const progressBarElement = document.getElementById(`${this.elementId}_progress-bar`);
    if (progressBarElement) {
      const progress = (remainingTime / this.duration) * 100;
      progressBarElement.style.width = progress + "%";
    }
  }

  startTimer() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      const remainingTime = this.endTime - Date.now();
      if (remainingTime > 0) {
        this.updateTimerDisplay();
        // Safely try to save to localStorage
        try {
          localStorage.setItem(`${this.elementId}_endTime`, this.endTime);
        } catch (e) {
          // localStorage might be blocked in some environments
          console.warn('localStorage not available for countdown timer');
        }
      } else {
        clearInterval(this.timer);
        this.endTime = Date.now() + this.duration;
        this.updateTimerDisplay();
        // Safely try to save to localStorage
        try {
          localStorage.setItem(`${this.elementId}_endTime`, this.endTime);
        } catch (e) {
          // localStorage might be blocked in some environments
          console.warn('localStorage not available for countdown timer');
        }
        this.startTimer();
      }
    }, 1000);
  }

  initialize() {
    // Check if we're on a page that should have countdown timers
    if (this.shouldInitialize()) {
      this.updateTimerDisplay();
      this.startTimer();
    }
  }
  
  shouldInitialize() {
    // Check if required elements exist
    const timerElement = document.getElementById(`${this.elementId}_timer`);
    const progressBarElement = document.getElementById(`${this.elementId}_progress-bar`);
    
    // Only initialize if both elements exist
    if (timerElement && progressBarElement) {
      console.log(`Countdown timer ${this.elementId} initialized successfully`);
      return true;
    }
    
    // If elements don't exist, don't initialize (prevents errors on product pages)
    console.log(`Countdown timer ${this.elementId} elements not found, skipping initialization`);
    return false;
  }
}

// Initialize countdown timers when DOM is ready
function initializeCountdownTimers() {
  const timer0 = new CountdownTimer(12 * 60 * 60 * 1000, "timer0");
  timer0.initialize();

  const productGrids = document.querySelectorAll(
    ".deal_zone .inner .product-grid"
  );

  productGrids.forEach((element, index) => {
    const adjustedIndex = index + 1;
    const adjustedIndexVariable = `timer${adjustedIndex}`;
    const newadjustedIndexVariable = new CountdownTimer(
      12 * 60 * 60 * 1000,
      adjustedIndexVariable
    );
    newadjustedIndexVariable.initialize();
  });
}

// Try to initialize immediately if DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCountdownTimers);
} else {
  initializeCountdownTimers();
}

// Also try on window load as fallback
window.addEventListener('load', initializeCountdownTimers);

$(document).ready(function () {
  $("header .header_right .dealzone").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $(".deal_zone").position().top + 129,
      },
      1000
    );
  });
});

$(function () {
  $(".assistance-section .tabs-nav a").click(function () {
    // Check for active
    $(".tabs-nav li").removeClass("active");
    $(this).parent().addClass("active");

    // Display active tab
    let currentTab = $(this).attr("href");
    $(".tabs-content .tab-item").hide();
    $(currentTab).show();

    return false;
  });
});

//Mobile menu show more / less
$(document).ready(function () {
  var showMoreLess = document.querySelector("#show_more_less div");
  $("#show_more_less").click(function () {
    $(".custom_mega_menu_mobile").toggleClass("Change_grid");
    if (showMoreLess.innerHTML === "Show More") {
      showMoreLess.innerHTML = "Show Less";
    } else {
      showMoreLess.innerHTML = "Show More";
    }
  });
});


$(".remove-all-button").click(function () {
  // console.log("addclass");
  $(this).parent().toggleClass("active");
});
$(document).ready(function () {
  $(" .dropdown_img_hero .mobile_arrow_custom").on("click", function () {
    $(this).closest(".dropdown_img_hero").toggleClass("show");
    $('.custom-video-overlay').css('display', 'none');
    $('.back_from_menu.first  ').addClass('remove');
  });
  $(".link_wrapper .menu__item_arrow ").on("click", function (event) {
    $(".submenu-container").removeClass("d-none");
    $(this)
      .closest(".link_wrapper")
      .find(".submenu-container .menu__level-02")
      .addClass("show");
    $(".custom_mega_menu_desktop").attr("data-mobile-level", "2");
    $('.custom-video-overlay').css('display', 'none');
    // console.log("menu__item_arrow");
    
  });

  $(".mobile_slider_bar .dropdown_img_hero .nested-links .side_bar_icon ").on(
    "click",
    function (event) {
      event.stopPropagation();
      // Toggle the 'show' class on the parent '.dropdown_img_hero' element
      $(this).closest(".dropdown_img_hero").removeClass("show");
      $('.back_from_menu.first  ').removeClass('remove');
    }
  );
  $(".custom_mega_menu_desktop .side_bar_icon.main ").on(
    "click",
    function (event) {
      event.preventDefault();

      $(this).closest(".menu__level-02").removeClass("show");
      $(".custom_mega_menu_desktop").attr("data-mobile-level", "1");
      // $(".custom_mega_menu_desktop").removeAttr("data-mobile-level");

      $(".dropdown_img_hero").removeClass("show");
      $(".submenu-container").addClass("d-none");
    }
  );
  $(".mobile_drawer_close").on("click", function () {
    console.log('working1');
    $(".dropdown_img_hero").removeClass("show");
    $('.back_from_menu.first  ').removeClass('remove');
    $(".submenu-container .menu__level-02").removeClass("show");
    
    $(".popup__body.position-relative.d-none.flex-lg-column").removeClass(
      "show visible"
    );
    $(".responsive__menu").removeClass("active show");
    $(
      ".popup__bg.fixed-stretch.cursor-pointer.pointer-events-none"
    ).removeClass("active show");
    $("body").removeClass(
      "offset-scrollHOLD offset-scroll-padding fixed-elem overflow-hiddenHOLD position-fixed left-0 w-100"
    );
    $("body").addClass(
      "CustomFixed "
    );
    $('html').removeClass('touchevents');
    $('html').addClass('no-touchevents');
    
    $('body').css('top', '');
    $('.custom-video-overlay').css('display', 'none');
    $(".custom_mega_menu_desktop").attr("data-mobile-level", "1");
    // $(".custom_mega_menu_desktop").removeAttr("data-mobile-level");

    $('#product_items').addClass('tab-a active-a');
    $('#services').removeClass('tab-a active-a');
    $('#account').removeClass('tab-a active-a');
    $('.custom_mega_menu_desktop').addClass('tab-active');
    $('.custom_mega_menu_desktop').css('display', 'block');
    $('.tab_service_footer').removeClass('tab-active');
    $('.tab_service_footer').css('display', 'none');

  });


  
});




  $(document).ready(function () {
    $('.sidbar_list').on('click', function () {
      // Remove active class from all sidebar items
      $('.sidbar_list').removeClass('active-a');
      $(this).addClass('active-a');

      // Get the target tab's ID
      var tabID = $(this).data('id');

      // Hide all tab content
      $('.tab').hide();

      // Show the selected tab content
      $('.tab[data-id="' + tabID + '"]').show();
    });
  });


  // Set up Ask a Question click handler
$(document).ready(function () {
   $(document).on('click', '.ask-question', function (event) {
      event.preventDefault();

      var targetButton = $('.yotpo-ask-question-btn-l');
      if (targetButton.length > 0) {
          const targetElement = targetButton[0];
          const clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true,
          });
          targetElement.dispatchEvent(clickEvent);
      }
  });  
});



$(document).ready(function() {
  var $carousel = $('.brand-images-carousel');
  if ($carousel.length) {
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }

    $carousel.slick({
      slidesToShow: 1, // Important for multi-row setup
      slidesToScroll: 1,
      rows: 2, // Default for desktop
      slidesPerRow: 8, // 2 rows × 5 items = 10 items visible
      autoplay: true,
      autoplaySpeed: 6000,
      arrows: true,
      dots: false,
      prevArrow: `<button type="button" class="slick-prev custom-slick-arrow" aria-label="Previous">
        <img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/slider-left-arrow.png?v=1751619724" alt="Previous" style="width:32px;height:32px;" />
      </button>`,
      nextArrow: `<button type="button" class="slick-next custom-slick-arrow" aria-label="Next">
        <img src="https://cdn.shopify.com/s/files/1/0134/3275/0138/files/slider-right-arrow.png?v=1751619696" alt="Next" style="width:32px;height:32px;" />
      </button>`,
      responsive: [
        {
          breakpoint: 1360, // Desktop
          settings: {
            rows: 2,
            slidesPerRow: 6
          }
        },
        {
          breakpoint: 1024, // Tablet
          settings: {
            rows: 2,
            slidesPerRow: 4
          }
        },
        {
          breakpoint: 767, // Mobile
          settings: {
            rows: 9,
            slidesPerRow: 2
          }
        }
      ]
    });
  }
});

// Home Gym Package body class toggler
(function() {
  function updateHomeGymBodyClass() {
    try {
      var hasHomeGym = !!document.querySelector('.home-gym-main .product_info');
      if (document.body) {
        document.body.classList.toggle('has-home-gym-package', hasHomeGym);
      }
    } catch (e) {
      // no-op
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHomeGymBodyClass);
  } else {
    updateHomeGymBodyClass();
  }

  window.addEventListener('load', updateHomeGymBodyClass);
  document.addEventListener('shopify:section:load', updateHomeGymBodyClass);

  var main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) {
    var observer = new MutationObserver(function() {
      updateHomeGymBodyClass();
    });
    observer.observe(main, { childList: true, subtree: true });
  }
})();

